import React, { useEffect, useState, createContext } from 'react'
import { node } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { updateConfigByLanguage, fetchConfiguration } from './actions'
import themeVariables from '../../styles/scss/configuration/_variables.scss'
import { selectConfigurationState } from '../../redux/configuration/selectors'
import { selectLanguage } from '../../redux/session/selectors'
const { Provider, Consumer } = createContext()

const ConfigProvider = ({ children }) => {
  const dispatch = useDispatch()
  const configuration = useSelector(selectConfigurationState)
  const languageCode = useSelector(selectLanguage)

  /*
    note:
    This local state ensures we always check on config (fetch or update)
    regardless of redux-persisted state
  */
  const [initialConfigsFetched, setInitialConfigsFetched] = useState(false)
  const [configContextValues] = useState({
    themeVariables,
    currentTheme: process.env.REACT_APP_FLOW_CLIENT_ID
  })

  useEffect(() => {
    /*
      If we have configuration data,
      silently update config with no success/error or other side effects
    */
    if (!initialConfigsFetched) {
      setInitialConfigsFetched(true)
      if (!configuration.data) {
        dispatch(fetchConfiguration())
      } else {
        dispatch(updateConfigByLanguage({ languageCode }))
      }
    }
  }, [dispatch, initialConfigsFetched, configuration.data, languageCode])

  return <Provider value={configContextValues}>{children}</Provider>
}

ConfigProvider.propTypes = {
  children: node.isRequired
}

export { ConfigProvider }
export default Consumer
